import './PreviewLinks.css';
import { Paper } from '@mui/material';
import ProfileView from '../ProfileView/ProfileView';
import { useAuth } from '../../context/AuthContext';
import EditableAvatar from '../EditableAvatar/EditableAvatar';

interface PreviewTheme {
  background?: {
    type?: 'solid' | 'gradient';
    solid?: string;
    gradient?: { left?: string; right?: string; direction?: string };
  };
  text?: { primary?: string; secondary?: string };
}

interface PreviewInfo {
  title?: string;
  description?: string;
}

interface PreviewLinksProps {
  links: any[];
  theme: PreviewTheme;
  info: PreviewInfo;
}

const PreviewLinks = ({ links, theme, info }: PreviewLinksProps) => {
  const { user: { username } } = useAuth() as any;

  return (
    <Paper className='profile-preview-links' variant='outlined' elevation={0}>
      <ProfileView
        className='profile-grid-preview-links'
        links={links}
        theme={theme}
        info={info}
        username={username}
        origin='preview'
        avatar={<EditableAvatar />}
      />
    </Paper>
  );
};

export default PreviewLinks;
